// @flow
import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

type GTMBannerCarouselViewed = {
  type: "BANNER_CAROUSEL_CLICKED",
  payload: {
    bannerName: string,
    bannerType: "promo" | "tutorial",
    bannerId: string | number
  }
};

type GTMBannerCarouselClick = {
  type: "BANNER_CAROUSEL_CLICKED",
  payload: {
    bannerName: string,
    linkUrl: string,
    bannerType: "promo" | "tutorial",
    bannerId: string | number,
    linkText: string
  }
};

type GTMHomepageTutorialsLearnMore = {
  type: "HOMEPAGE_TUTORIALS_LEARN_MORE",
  payload: {
    article: string,
    linkUrl: string,
    position: number
  }
};

export default () => {
  mediatorChannels.base.subscribe(
    "BANNER_CAROUSEL_VIEWED",
    (data: GTMBannerCarouselViewed) => {
      pushToDataLayer({
        event: "banner",
        gaEventCategory: "Banner",
        gaEventAction: "Banner Viewed",
        gaEventLabel: get(data, "payload.bannerName"),
        module: "hero_carousel",
        destinationUrl: undefined,
        bannerType: get(data, "payload.bannerType"),
        bannerId: get(data, "payload.bannerId"),
        bannerName: get(data, "payload.bannerName"),
        linkText: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "BANNER_CAROUSEL_CLICKED",
    (data: GTMBannerCarouselClick) => {
      pushToDataLayer({
        event: "banner",
        gaEventCategory: "banner",
        gaEventAction: "Banner Link Clicked",
        gaEventLabel: get(data, "payload.bannerName"),
        module: "hero_carousel",
        linkUrl: get(data, "payload.linkUrl"),
        bannerType: get(data, "payload.bannerType"),
        bannerId: get(data, "payload.bannerId"),
        bannerName: get(data, "payload.bannerName"),
        linkText: get(data, "payload.linkText")
      });
    }
  );

  mediatorChannels.base.subscribe(
    "HOMEPAGE_TUTORIALS_LEARN_MORE",
    (data: GTMHomepageTutorialsLearnMore) => {
      pushToDataLayer({
        event: "navigation",
        gaEventCategory: "Navigation",
        gaEventAction: "Navigation Link Clicked",
        gaEventLabel: get(data, "payload.article"),
        module: "prep_for_derby",
        linkText: get(data, "payload.article"),
        linkUrl: get(data, "payload.linkUrl"),
        tag: get(data, "payload.position")
      });
    }
  );
};
